import { Translation } from '@ps/web-shared-components';
import React from 'react';

import type { DepositContext, DepositResult } from '../../../../../../types/Cashier';
import RejectedCommon from '../RejectedCommon/RejectedCommon';

import { TXTWCL_You_must_wait_for_your_last_de_ELL } from './AnotherInProgress.messages.json';

type Props = DepositResult & DepositContext;

const AnotherInProgress: React.FC<Props> = () => (
  <RejectedCommon>
    <Translation {...TXTWCL_You_must_wait_for_your_last_de_ELL} />
  </RejectedCommon>
);

export default AnotherInProgress;
